import { Injectable } from "@angular/core";
import { MapsService } from "../maps/maps.service";
import { Store } from '@ngrx/store';
import { ShippingState } from '../../../../store/shipping/shipping.reducer';
import * as ShippingActions from '../../../../store/shipping/shipping.actions';
declare const google: any;
@Injectable({
  providedIn: 'root'
})
export class CostTrackingService {
  constructor(
    private mapsService: MapsService,

    private store: Store<{ shipping: ShippingState }>
  ) { }

  calculateDistance(
    origin: { latitude: string; longitude: string },
    destination: { latitude: string; longitude: string }
  ): Promise<{ distance: number; duration: number }> {
    return new Promise(async (resolve, reject) => {
      try {
        await this.mapsService.loadGoogleMapsScript();
        const directionsService = new google.maps.DirectionsService();
        const request = {
          origin: new google.maps.LatLng(
            parseFloat(destination.latitude),
            parseFloat(destination.longitude)
          ),
          destination: new google.maps.LatLng(
            parseFloat(origin.latitude),
            parseFloat(origin.longitude)
          ),
          travelMode: google.maps.TravelMode.TWO_WHEELER
        };
        directionsService.route(request, (result: {
          routes: {
            legs: {
              distance: { value: number; };
              duration: { value: number; };
            }[];
          }[];
        },
          status: string) => {
          let duration: number = 0;
          let distance: number = 0;

          if (status === 'OK' && result.routes[0]) {
            // Google Maps calculation


            // console.log('distance original', result.routes[0].legs[0].distance.value);

            distance = Math.round(result.routes[0].legs[0].distance.value / 1000);
            // console.log('distance round', distance);
            // Standard rounding for duration (up if > 0.5, down if ≤ 0.5)
            const rawDuration = result.routes[0].legs[0].duration.value / 60;
            duration = Math.round(rawDuration);
          }
          // this.processPaymentService.distance = distance;
          // this.processPaymentService.timeGoogle = duration + 15;
          //this.store.dispatch(ShippingActions.SetDistanceKm({ distanceKm: distance.toString() }));
          this.store.dispatch(ShippingActions.setTime({ time: (duration ).toString() }));
          resolve({
            distance,
            duration
          });
        });

      } catch (error) {
        console.error('Error calculating distance and time:', error);
        reject(error);
      }
    });
  }
}
